import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Box,
  Chip,
  IconButton,
} from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";
import { axiosConfig } from "../../axios/axiosConfig";
const WithdrawalTicketDetailsModal = ({ open, onClose, ticketId }) => {
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const [error, setError] = useState(null);

  const fetchDetails = async () => {
    if (!ticketId) return;
    setLoading(true);
    setError(null);
    try {
      // const endpoint = `/tnibroadmin/get-withdrawl-request-by-ticket/?ticket_id=${encodeURIComponent(
      //   ticketId
      // )}`;
      const res = await axiosConfig({
        method: "get",
        url: "/tnibroadmin/get-withdrawl-request-by-ticket/",
        params: { ticket_id: ticketId }, // send ticketId as query param
      });
      setDetails(res.data?.response || []);
    } catch (err) {
      const msg =
        err.response?.status === 404
          ? `No details found for ticket ${ticketId}`
          : "Failed to fetch ticket details";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchDetails();
    } else {
      setDetails([]);
      setError(null);
    }
  }, [open, ticketId]);

  // Map boolean status to label and color
  const renderStatus = (status) => {
    return status ? (
      <Chip label="Completed" color="success" size="small" />
    ) : (
      <Chip label="Pending" color="warning" size="small" />
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Ticket Details: {ticketId}
        <IconButton onClick={onClose} disabled={loading}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" p={2}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" align="center" sx={{ py: 2 }}>
            {error}
          </Typography>
        ) : details.length === 0 ? (
          <Typography align="center" sx={{ py: 2 }}>
            No details found.
          </Typography>
        ) : (
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 300,
              overflowY: "auto",
              overflowX: "hidden",
              "&::-webkit-scrollbar": { width: 0, height: 0 },
            }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>User</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Phone</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Plan</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Referral</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Status</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Date</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {details.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.username}</TableCell>
                    <TableCell>{item.phoneno}</TableCell>
                    <TableCell>{item.plan_name}</TableCell>
                    <TableCell>₹{item.referral_amount}</TableCell>
                    <TableCell>
                      {renderStatus(item.withdrawal_status)}
                    </TableCell>
                    <TableCell>
                      {new Date(item.created_at).toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default WithdrawalTicketDetailsModal;
